/**
* Specials Archive JS
* -----------------------------------------------------------------------------
*
* All the JS for the Specials Archive component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'specials-archive',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const specialsCount = $( '.specials-archive[data-specials-count]' ).text();
      if ( specialsCount == 0 ) {
        window.location.href = '/greenlight-marijuana-specials/';
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'specials-archive', COMPONENT );
} )( app );
